import React from "react";
import { commonStr } from "../../utils/constants/commonStrings";

const CommonNoRecord = ({ title = commonStr.noSession }) => {
  return <div className="displayFlexCenter h-100">{title}</div>;
};

export default CommonNoRecord;
